/* eslint-disable no-magic-numbers */
import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

import { SvgIcon } from '../SvgIcon';
import { positionExternalTooltipElements } from './utils/position-external-tooltip-elements';
import { positionTooltipElements } from './utils/position-tooltip-elements';

export const Tooltip = ( {
    hideArrow,
    noPadding,
    theme,
    direction,
    tooltipTarget,
    externalTooltipWrapper,
    primaryTooltipContent,
    secondaryTooltipContent
} ) => {
    const wrapper = useRef();
    const arrow = useRef();
    const primary = useRef();

    const [ isSecondaryOpen, setIsSecondaryOpen ] = useState( false );

    useLayoutEffect( () => {
        if ( tooltipTarget && externalTooltipWrapper ) {
            // Position the external tooltip.
            positionExternalTooltipElements( {
                target: tooltipTarget,
                wrapper: wrapper.current,
                primary: primary.current,
                arrow: arrow.current,
                direction
            } );
        } else {
            // Adjust the natural horizontal position of the tooltip (if needed)
            // to ensure it appears fully within the viewport.
            positionTooltipElements( wrapper.current );
        }
    }, [ tooltipTarget, primaryTooltipContent, secondaryTooltipContent ] );

    const tooltipComponent = (
        <div
            ref={ wrapper }
            className={ classNames( `tooltip-button__wrapper  tooltip-button__wrapper--theme-${ theme } tooltip-button__wrapper--direction-${ direction }`, {
                'tooltip-button__wrapper--outside': externalTooltipWrapper,
                'tooltip-button__wrapper--hide-arrow': hideArrow
            } ) }
        >

            {/* The secondary tooltip. */}
            <div className={ classNames( 'tooltip-button__secondary-tooltip-wrapper', {
                'tooltip-button__secondary-tooltip-wrapper--hidden': !isSecondaryOpen,
                'tooltip-button__secondary-tooltip-wrapper--no-padding': noPadding
            } ) }>
                { secondaryTooltipContent }
            </div>

            {/* The primary tooltip arrow. */}
            <div
                ref={ arrow }
                className="tooltip-button__arrow"
            />

            {/* The primary tooltip. */}
            <div
                ref={ primary }
                className={ classNames( 'tooltip-button__primary-tooltip-wrapper', {
                    'tooltip-button__primary-tooltip-wrapper--no-padding': noPadding
                } ) }
            >

                {/* The tooltip content. */}
                { primaryTooltipContent }

                {/* The button to open the secondary tooltip. */}
                { secondaryTooltipContent && (
                    <button
                        aria-label='More info'
                        className="tooltip-button__secondary-tooltip-button"
                        onClick={ () => setIsSecondaryOpen( val => !val ) }
                    >
                        <SvgIcon icon="info-circle" />
                    </button>
                ) }
            </div>
        </div>
    );

    if ( externalTooltipWrapper ) {
        return ReactDOM.createPortal( tooltipComponent, externalTooltipWrapper );
    }

    return tooltipComponent;
};

Tooltip.propTypes = {
    hideArrow: PropTypes.bool,
    noPadding: PropTypes.bool,
    primaryTooltipContent: PropTypes.any.isRequired,
    secondaryTooltipContent: PropTypes.any,
    tooltipTarget: PropTypes.any.isRequired,
    externalTooltipWrapper: PropTypes.any,
    theme: PropTypes.oneOf( [ 'light', 'dark' ] ),
    direction: PropTypes.oneOf( [ 'above', 'below' ] )
};